import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-newly-added-tenders',
  templateUrl: './newly-added-tenders.component.html',
  styleUrls: ['./newly-added-tenders.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewlyAddedTendersComponent implements OnInit {
  // @Input() tenders: Array<any> = [];
  // @Input() type: string = "";
  // @Input() dataType: any;

  numberOfItems: number = 1;
  isScroll: boolean = true;
  containerId: string = "slider-" + Math.random().toString(36).substr(2, 9);
  hideContainer = false;
  topPerformingContainer = 'top-performing-inner-container2';
  isLeftVisible: boolean = false;
  isRightVisible: boolean = true;

  baseUrl: any = environment.TENDER.BASE_URL;

  isMobile: boolean = true;
  newTendersList: any[] = []; // Initialize to an empty array

  constructor(private sharedService: SharedService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.loadNewlyAddedTenders();
  }

  loadNewlyAddedTenders() {
    this.activatedRoute.data.subscribe((rawData: any) => {
      let resolverData: any = rawData['tendersResolver'];
      if (resolverData?.newlyadded) {
        this.newTendersList = resolverData?.newlyadded?.data;
      }
    });
  }

  /**
   * Navigate to all tenders page with full page reload
   * This bypasses Angular's internal routing and triggers a full page reload
   * to pull fresh data from the CDN instead of using cached data
   */
  navigateToAllTenders(event: Event) {
    event.preventDefault(); // Prevent default behavior
    // Use window.location.href to reload the page and pull fresh data from CDN
    window.location.href = '/all-tenders/active';
  }

  /**
   * Navigate to tender details page with full page reload
   * This bypasses Angular's internal routing and triggers a full page reload
   * to pull fresh data from the CDN instead of using cached data
   */
  navigate(link: string): void {
    // Construct full URL using baseUrl and the detailPageUrl
    const fullUrl = this.baseUrl + link;
    window.location.href = fullUrl;
  }

  onSliderScroll(event: Event): void {
    const { isRightVisible, isLeftVisible } = this.sharedService.onScroll(event);
    this.isRightVisible = isRightVisible;
    this.isLeftVisible = isLeftVisible;
  }

  scrollSliderDiv(right?: any): void {
    this.sharedService.scrollDiv(this.containerId, this.numberOfItems, right);
  }

   // TrackBy function for optimizing DOM updates
   trackByTenderId(index: number, tender: any): number {
    return tender.id || index; // Return unique identifier, or index if no id
  }

}
